export default "__VITE_ASSET__4c152bab__"